import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './LoginForm.css';
import { useAuth } from '../../state/AuthContext';
import Field from '../common/Field/Field';
import { AUTH_ROUTES, getPublicOnlyRedirect } from '../../routes/routingContract';

export default function LoginForm() {
  const { login, error, setError } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const emailValid = /.+@.+\..+/.test(email.trim());
  const passwordValid = password.length >= 1;
  const canSubmit = emailValid && passwordValid;

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit || loading) return;
    
    setLoading(true);
    setError(null);
    try {
      const payload = {
        email: email.trim(),
        phone: null,
        password,
        captcha_token: null,
      };
      await login(payload);
      navigate(getPublicOnlyRedirect(location.state), { replace: true });
    } catch (err) {
      // Generic error message for security - don't reveal if email exists
      if (err.status === 429) {
        setError('Too many login attempts. Please try again later.');
      } else {
        setError('Login failed. Please check your email and password and try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form onSubmit={onSubmit}>
        <div className="login-form">
          <div className="form-header">
            
            <h2>Welcome to Wealth-Y</h2>
            <p className="subtitle">Log in to manage your financial future.</p>
          </div>
          <Field
            label="Email Address"
            name="email"
            type="email"
            value={email}
            onChange={(e)=>setEmail(e.target.value)}
            placeholder="you@mail.com"
            icon="email"
            valid={email ? emailValid : undefined}
          />
          <Field
            label="Password"
            name="password"
            type="password"
            value={password}
            onChange={(e)=>setPassword(e.target.value)}
            placeholder="••••••••"
            icon="lock"
            withEye
            showPassword={showPassword}
            onToggleShow={() => setShowPassword(v => !v)}
            valid={password ? passwordValid : undefined}
          />
          <div className="form-actions left">
            <Link to={AUTH_ROUTES.forgotPassword} className="link">Forgot your password?</Link>
          </div>
          {error && <div className="error" role="alert">{error}</div>}
          <button type="submit" disabled={!canSubmit || loading} className="btn-primary">
            {loading ? 'Signing in…' : 'Continue'}
          </button>
        </div>
      </form>

    </>
  );
}
